<template>
	<picture>
		<source v-for="(source, i) in normalizedSources" :key="i" :srcset="source.srcset" :type="source.type" :media="source.media" />
		<img :src="src" :alt="alt" v-bind="$attrs" />
	</picture>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
	src: { type: String, required: true },
	sources: { type: [Array, Object], default: () => [] },
	alt: { type: String, default: "" },
});

const normalizedSources = computed(() => {
	if (Array.isArray(props.sources)) {
		return props.sources.map((src) => {
			// если source уже содержит media, не трогаем
			if (src.media) return src;
			// если media нет, просто возвращаем
			return src;
		});
	}
	if (props.sources && typeof props.sources === "object") {
		return Object.entries(props.sources).map(([type, srcset]) => ({
			type: `image/${type}`,
			srcset,
			media: undefined, // если хочешь можно добавить media по умолчанию
		}));
	}
	return [];
});
</script>
